
export enum ModelValue {
  Model1 = 1,
  Model2 = 2,
}
